import react, { useContext, useEffect, useReducer, useMemo } from 'react'
import ColorButton from '../../Buttons/ColorButton'
import Table from '../../Table'
import { lockedReducer } from '../../Utils/reducers'
import { externalComponent } from '../../AppRoutes'
import { api } from '../../../services/api'
import toast from 'react-hot-toast'
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { customTheme } from '../../theme/textfieldTheme'
import { FormControl, MenuItem, Select, TextField } from '@mui/material'
import MegaAutoComplete from '../../Utils/megautocomplete'

let timeout = 0
const timeoutTime = 0

const submit = async (state, setState, setLoader) => {
    setLoader(true)
    const res = await api.post('tipo_documento/', state.rows)
    if (res.status === 200){
        toast.success('Dados salvos com sucesso')
    } else {
        toast.error('Erro: Dados não foram salvos')
    }
    setLoader(false)
}

const changeData = (props, rows, newvalue, setState, extra = {}) => {
    clearTimeout(timeout)
    const row = rows.find(row => row.id === props.row.id)
    const value = { id: props.row.id, [props.field]: newvalue, ...extra }
    Object.assign(row, value)
    props.api.updateRows([value])
    timeout = setTimeout(() => {
        setState({ products_rows: [...rows] })
    }, timeoutTime)
}



const getcolumns = (rows, setState) => {
    const columns = []
    columns.push({ field: 'label', headerName: 'Nome', flex: 1 })
    columns.push({ field: 'tipo', headerName: 'Tipo', flex: 1, renderCell: (props) => (
    <MegaAutoComplete
        size='small'
        key={'mega-auto-complete-debito'}
        value={props.value}
        initializeOptions={props.value ? [props.value] : null}
        onChange={(d) => { changeData(props, rows, d, setState)}}
        noOptionsText={'Digite para procurar uma condição de pagamento'}
        timeoutUrl='/novopedido/condicao_pagamento/?debito=true'
        timeoutParam='label'
        label='Condição de Pagamento'
    />
) })
    return columns
}

const initialize = async (setState, setLoader) => {
    setLoader(true)
    const res = await api.get('tipo_documento/')
    if (res.status === 200)
        setState({ rows: res.data, ready: true })
    else
        toast.error('Falha ao recuperar os tipos de documento')
    setLoader(false)
}

const TipoDoc = () => {

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        loading: false,
        rows: [],
        ready: false
    })

    useEffect(() => {
        initialize(setState, setLoader)
    }, [])

    const outerTheme = useTheme()

    const setColumns = useMemo(() => getcolumns(state.rows, setState), [state.rows])

    return (
        <>
            <ColorButton onClick={() => submit(state, setState, setLoader)} sx={{ maxWidth: '10rem' }}>Salvar</ColorButton>
            {/* <ThemeProvider theme={customTheme(outerTheme)}> */}
                {state.ready &&
                    <Table
                        disableRowSelectionOnClick
                        paginationMode='client'
                        className='contabil-grid'
                        rows={state.rows}
                        columns={setColumns}
                        pagination={false}
                        toolbar
                        slots={{
                            filterComponent: true,
                            columnComponent: true
                        }}
                        density='compact'
                        rowHeight={30}
                    />}
            {/* </ThemeProvider> */}
        </>
    )
}

export default TipoDoc